import React from "react";
import { RouterProvider } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import StarterContainer from "./components/common/StarterContainer";
import TenantThemeProvider from "./util/tenent-theme-provider";
import TranslationProvider from "./util/translation-provider";
import { getTenantId } from "./util/common-functions";
import BaseSiteHomePage from "./pages/base-site/home";
import withStarterContainer from "./components/common/StarterContainer";
import InactivityTracker from "./components/inactivity-tracker/inactivity-tracker";
import AutoCloseListener from "./components/pos/auto-close/AutoCloseListener";
import AuthLogoutListener from "./components/auth/AuthLogoutListener";
import { UserNoteProvider } from "./providers/UserNoteProvider";
import { SnackbarProvider } from "./providers/SnackbarProvider";
import ResponsiveProvider from "./providers/ResponsiveProvider";
import { ErrorBoundary } from "./components/common/ErrorBoundary";
import { store } from "./redux/store";
import { setUnauthorizedHandler } from "./configs/axiosConfig";
import { logoutAction } from "./redux/actions/authAction";
import reportWebVitals from "./reportWebVitals";
import { routers } from "./configs";
import "./index.css";
import "./tailwind.css";

setUnauthorizedHandler(() => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  store.dispatch(logoutAction());
});

const container = document.getElementById("root")!;
const root = createRoot(container);
const tenantId = getTenantId();

if (!tenantId) {
  root.render(
    <React.StrictMode>
      <TenantThemeProvider tenantId={tenantId || ""}>
        <BaseSiteHomePage />
      </TenantThemeProvider>
    </React.StrictMode>
  );
} else {
  const WithInitializer = withStarterContainer(() => (
    <RouterProvider router={routers} />
  ));
  root.render(
    <ErrorBoundary>
      <ResponsiveProvider>
        <TenantThemeProvider tenantId={tenantId || ""}>
          <TranslationProvider tenantId={tenantId || ""}>
            <Provider store={store}>
              <UserNoteProvider>
                <SnackbarProvider>
                  <AutoCloseListener />
                  <AuthLogoutListener />
                  <InactivityTracker />
                  <WithInitializer />
                </SnackbarProvider>
              </UserNoteProvider>
            </Provider>
          </TranslationProvider>
        </TenantThemeProvider>
      </ResponsiveProvider>
    </ErrorBoundary>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
